import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule } from "@angular/core";
import { CoreModule } from "@obg/ngx.core";
import { CoreContentModule } from "@obg/ngx.core.content";

import { ComponentFactoryService } from "../component-factory/component-factory.service";

import { ImageContentDirective } from "./image-content.directive";

const IMAGE_CONTENT_DIRECTIVES = [ImageContentDirective];

@NgModule({
	imports: [CoreModule, CommonModule, CoreContentModule],
	exports: IMAGE_CONTENT_DIRECTIVES,
	declarations: IMAGE_CONTENT_DIRECTIVES,
})
export class ImageContentDirectiveModule {
	constructor(componentFactoryService: ComponentFactoryService, resolver: ComponentFactoryResolver) {
		componentFactoryService.registerLazyLoadedResolver(resolver, ...IMAGE_CONTENT_DIRECTIVES);
	}
}
